var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Tooltip } from "@mui/material";
import { classifySTOrderDetailsOrderRow, getSTOrderDetailsStatusChipBgColor, getSTOrderDetailsStatusDisplayLabel, } from "../model/stOrderDetailsOrderStatus";
/** Status badge for Sales Order Details grid rows (server status → label + colour). */
var STOrderDetailsStatusChip = function (_a) {
    var _b;
    var status = _a.status, order = _a.order;
    var raw = (_b = status !== null && status !== void 0 ? status : order === null || order === void 0 ? void 0 : order.OrderStatus) !== null && _b !== void 0 ? _b : order === null || order === void 0 ? void 0 : order.status;
    var label = getSTOrderDetailsStatusDisplayLabel(raw);
    if (label === "-") {
        return _jsx("span", { children: "-" });
    }
    var bgcolor = getSTOrderDetailsStatusChipBgColor(raw);
    return (_jsx(Tooltip, __assign({ title: label }, { children: _jsx(Chip, { className: "ST_ChipTag", label: label, sx: { bgcolor: bgcolor, color: "white" } }) })));
};
export { classifySTOrderDetailsOrderRow, STOrderDetailsStatusChip };
